import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../Providers/AuthProvider";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import UpdateTourFormFirstStep from "../UpdateTourForm/UpdateTourFormFirstStep";
import { getPackageNaturePlanInfoService } from "../../services/getPackageNaturePlanInfo";
import SaveTourInfoService from "../../services/SaveTourInfo";
import "animate.css";
import TrackVisibility from "react-on-screen";
import ContentLoading from "../Loading/Loading";
import { goToTop } from "../../utiles/GotoTop";

const ManageTourSecondStep = ({ nextStepTab, prevStepTab }) => {
  const [submitTracker, setSubmitTracker] = useState(0);
  const [stepFlag, setStepFlag] = useState(false);
  const nextStepFlag = (flag) => {
    setStepFlag(flag);
  };
  const [tour, setTour] = useState({
    ActivityRate: "",
    DeparturePlaceSR: "",
    DifficultyLevelSR: "",
    Meal: "",
    MinPrice: "",
    MoveTime: "",
    RecommendedStuffSR: "",
    RequiredStuffSR: "",
    ReturnTime: "",
    StayTimeSR: "",
    VehicleTypeSR: "",
  });
  const chnageTourHandler = (name, value) => {
    setTour({ ...tour, [name]: value });
  };
  const [requierdToolsList, setRequierdToolsList] = useState([]);
  const [suggestedToolsList, setSuggestedToolsList] = useState([]);

  const suggestedToolsListHandler = (item) => {
    console.log(item);
    if (item.title !== "") {
      setSuggestedToolsList([...suggestedToolsList, item]);
    }
  };
  const suggestedToolsListRemoveHandler = (id) => {
    const fiteredList = suggestedToolsList.filter((item) => item.id !== id);
    setSuggestedToolsList(fiteredList);
  };
  const requierdToolsListHandler = (item) => {
    console.log(item);
    if (item.title !== "") {
      setRequierdToolsList([...requierdToolsList, item]);
    }
  };
  const requierdToolsListRemoveHandler = (id) => {
    const fiteredList = requierdToolsList.filter((item) => item.id !== id);
    setRequierdToolsList(fiteredList);
  };
  const [error, setError] = useState(null);
  const { stateAuth } = useAuth();
  const [loading, setLoading] = useState(true);
  let params = useParams();
  // const [searchParams, setSearchParams] = useSearchParams();
  // const id = searchParams.get("id");
  // console.log(id);

  useEffect(() => {
    const requestData = {
      packageid: params.id,
    };
    const getPackageNaturePlanInfo = async () => {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      try {
        const { data } = await getPackageNaturePlanInfoService(
          requestData,
          header
        );
        if (data.Value.length > 0) {
          setTour({
            ActivityRate:
              data.Value[0].ActivityRate === "کم"
                ? 0
                : data.Value[0].ActivityRate === "متوسط"
                ? 1
                : 2,
            DeparturePlaceSR: data.Value[0].DeparturePlaceSR,
            DifficultyLevelSR:
              data.Value[0].DifficultyLevelSR === "کم"
                ? 0
                : data.Value[0].DifficultyLevelSR === "متوسط"
                ? 1
                : 2,
            Meal:
              data.Value[0].Meal === "ندارد"
                ? 0
                : data.Value[0].Meal === "یک وعده"
                ? 1
                : data.Value[0].Meal === "دو وعده"
                ? 2
                : data.Value[0].Meal === "سه وعده"
                ? 3
                : data.Value[0].Meal === "چهار وعده"
                ? 4
                : data.Value[0].Meal === "پنج وعده"
                ? 5
                : data.Value[0].Meal === "شش وعده"
                ? 6
                : data.Value[0].Meal === "هفت وعده"
                ? 7
                : data.Value[0].Meal === "هشت وعده"
                ? 8
                : data.Value[0].Meal === "نه وعده"
                ? 9
                : data.Value[0].Meal === "ده وعده"
                ? 10
                : 11,
            MinPrice: data.Value[0].MinPrice,
            MoveTime: data.Value[0].MoveTime,
            RecommendedStuffSR: data.Value[0].RecommendedStuffSR,
            RequiredStuffSR: data.Value[0].RequiredStuffSR,
            ReturnTime: data.Value[0].ReturnTime,
            StayTimeSR:
              data.Value[0].StayTimeSR === "نیم روزه"
                ? 0
                : data.Value[0].StayTimeSR === "یک روزه"
                ? 1
                : data.Value[0].StayTimeSR === "یک و نیم روزه"
                ? 2
                : data.Value[0].StayTimeSR === "دو روزه"
                ? 3
                : data.Value[0].StayTimeSR === "دو و نیم روزه"
                ? 4
                : data.Value[0].StayTimeSR === "سه روزه"
                ? 5
                : data.Value[0].StayTimeSR === "سه و نیم روزه"
                ? 6
                : data.Value[0].StayTimeSR === "چهار روزه"
                ? 7
                : data.Value[0].StayTimeSR === "چهار و نیم روزه"
                ? 8
                : data.Value[0].StayTimeSR === "پنج روزه"
                ? 9
                : data.Value[0].StayTimeSR === "پنج و نیم روزه"
                ? 10
                : data.Value[0].StayTimeSR === "شش روزه"
                ? 11
                : data.Value[0].StayTimeSR === "شش و نیم روزه"
                ? 12
                : data.Value[0].StayTimeSR === "هفت روزه"
                ? 13
                : data.Value[0].StayTimeSR === "هفت و نیم روزه"
                ? 14
                : data.Value[0].StayTimeSR === "هشت روزه"
                ? 15
                : data.Value[0].StayTimeSR === "هشت و نیم روزه"
                ? 16
                : 17,
            VehicleTypeSR:
              data.Value[0].VehicleTypeSR === "TBUS"
                ? 0
                : data.Value[0].VehicleTypeSR === "BUSVIP"
                ? 1
                : data.Value[0].VehicleTypeSR === "VIPBUS32"
                ? 2
                : data.Value[0].VehicleTypeSR === "MIDBUS"
                ? 3
                : data.Value[0].VehicleTypeSR === "TRAIN"
                ? 4
                : data.Value[0].VehicleTypeSR === "PCAR"
                ? 5
                : data.Value[0].VehicleTypeSR === "OFFROAD"
                ? 6
                : 7,
          });
        } else {
          setTour({
            ActivityRate: "",
            DeparturePlaceSR: "",
            DifficultyLevelSR: "",
            Meal: "",
            MinPrice: "",
            MoveTime: "00:00",
            RecommendedStuffSR: "",
            RequiredStuffSR: "",
            ReturnTime: "00:00",
            StayTimeSR: "",
            VehicleTypeSR: "",
          });
        }
        setLoading(false);
        formik.resetForm();
      } catch (error) {
        console.log(error);
      }
    };
    getPackageNaturePlanInfo();
  }, [submitTracker]);
  useEffect(() => {
    let PackageRequiredStuffArray = [];
    let PackageRecommendedStuffArray = [];
    const resultRequired = [];
    const resultRecomended = [];
    if (tour.RequiredStuffSR) {
      let PackageRequiredStuffText = tour.RequiredStuffSR;
      const re = /\s*(?:,|$)\s*/;
      PackageRequiredStuffArray = PackageRequiredStuffText.split(re);
      PackageRequiredStuffArray.pop();
      PackageRequiredStuffArray.forEach((item) => {
        resultRequired.push({
          id: Math.floor(Math.random() * 1000),
          title: item,
        });
      });
      setRequierdToolsList(resultRequired);
    }
    if (tour.RecommendedStuffSR) {
      let PackageRecommendedStuffText = tour.RecommendedStuffSR;
      const re = /\s*(?:,|$)\s*/;
      PackageRecommendedStuffArray = PackageRecommendedStuffText.split(re);
      PackageRecommendedStuffArray.pop();
      PackageRecommendedStuffArray.forEach((item) => {
        resultRecomended.push({
          id: Math.floor(Math.random() * 1000),
          title: item,
        });
      });
      setSuggestedToolsList(resultRecomended);
    }
  }, [tour.RequiredStuffSR, tour.RecommendedStuffSR]);

  /*************** formik **************/
  const hardshipLevelOptions = [
    { value: "کم", label: "کم" },
    { value: "متوسط", label: "متوسط" },
    { value: "زیاد", label: "زیاد" },
  ];
  const activityRateOptions = [
    { value: "کم", label: "کم" },
    { value: "متوسط", label: "متوسط" },
    { value: "زیاد", label: "زیاد" },
  ];

  const wehicleOptions = [
    { value: "TBUS", label: "اتوبوس توریستی" },
    { value: "BUSVIP", label: "اتوبوس VIP (25 نفره)" },
    { value: "VIPBUS32", label: "اتوبوس VIP (32 نفره)" },
    { value: "MIDBUS", label: "میدل باس" },
    { value: "TRAIN", label: "قطار" },
    { value: "PCAR", label: "وسیله نقلیه شخصی" },
    { value: "OFFROAD", label: "ماشین آفرود" },
    { value: "", label: "" },
  ];
  const stayingTimeOptions = [
    { value: "نیم روزه", label: "نیم روزه" },
    { value: "یک روزه", label: "یک روزه" },
    { value: "یک و نیم روزه", label: "یک و نیم روزه" },
    { value: "دو روزه", label: "دو روزه" },
    { value: "دو و نیم روزه", label: "دو و نیم روزه" },
    { value: "سه روزه", label: "سه روزه" },
    { value: "سه و نیم روزه", label: "سه و نیم روزه" },
    { value: "چهار روزه", label: "چهار روزه" },
    { value: "چهار و نیم روزه", label: "چهار و نیم روزه" },
    { value: "پنج روزه", label: "پنج روزه" },
    { value: "پنج و نیم روزه", label: "پنج و نیم روزه" },
    { value: "شش روزه", label: "شش روزه" },
    { value: "شش و نیم روزه", label: "شش و نیم روزه" },
    { value: "هفت روزه", label: "هفت روزه" },
    { value: "هفت و نیم روزه", label: "هفت و نیم روزه" },
    { value: "هشت روزه", label: "هشت روزه" },
    { value: "هشت و نیم روزه", label: "هشت و نیم روزه" },
    { value: "", label: "" },
  ];
  const mealOptions = [
    { value: "ندارد", label: "ندارد" },
    { value: "یک وعده", label: "یک وعده" },
    { value: "دو وعده", label: "دو وعده" },
    { value: "سه وعده", label: "سه وعده" },
    { value: "چهار وعده", label: "چهار وعده" },
    { value: "پنج وعده", label: "پنج وعده" },
    { value: "شش وعده", label: "شش وعده" },
    { value: "هفت وعده", label: "هفت وعده" },
    { value: "هشت وعده", label: "هشت وعده" },
    { value: "نه وعده", label: "نه وعده" },
    { value: "ده وعده", label: "ده وعده" },
    { value: "بیش از ده وعده", label: "بیش از ده وعده" },
  ];

  const initialValues = {
    DifficultyLevelSR: hardshipLevelOptions[tour.DifficultyLevelSR]
      ? hardshipLevelOptions[tour.DifficultyLevelSR]
      : tour.DifficultyLevelSR,
    ActivityRate: activityRateOptions[tour.ActivityRate]
      ? activityRateOptions[tour.ActivityRate]
      : tour.ActivityRate,
    Meal: mealOptions[tour.Meal] ? mealOptions[tour.Meal] : tour.Meal,
    DeparturePlaceSR: tour.DeparturePlaceSR,
    MinPrice: "",
    MoveTime: tour.MoveTime,
    ReturnTime: tour.ReturnTime,
    RequiredStuffSR: requierdToolsList,
    RecommendedStuffSR: suggestedToolsList,
    VehicleTypeSR: wehicleOptions[tour.VehicleTypeSR]
      ? wehicleOptions[tour.VehicleTypeSR]
      : tour.VehicleTypeSR,
    StayTimeSR: stayingTimeOptions[tour.StayTimeSR]
      ? stayingTimeOptions[tour.StayTimeSR]
      : tour.StayTimeSR,
  };
  const validationSchema = Yup.object({
    DifficultyLevelSR: Yup.object().required(
      "لطفا درجه سختی تور را مشخص نمایید."
    ),
    ActivityRate: Yup.object().required(
      "لطفا میزان فعالیت تور را مشخص نمایید."
    ),
    Meal: Yup.object().required("لطفا تعداد وعده های غذایی را وارد نمایید."),
    DeparturePlaceSR: Yup.string().required(
      "لطفا محل حرکت تور خود را وارد نمایید."
    ),
    //MinPrice: Yup.string().required("لطفا قیمت تور خود را وارد نمایید."),
    MoveTime: Yup.string().required("لطفا زمان حرکت تور خود را وارد نمایید."),
    ReturnTime: Yup.string().required(
      "لطفا زمان بازگشت تور خود را وارد نمایید."
    ),
    VehicleTypeSR: Yup.object().required(
      "لطفا نوع وسیله نقلیه را وارد نمایید."
    ),
    StayTimeSR: Yup.object().required("لطفا مدت تور خود را وارد نمایید."),
  });

  const onSubmit = async (values) => {
    const packageId = params.id;
    const {
      DifficultyLevelSR,
      ActivityRate,
      Meal,
      DeparturePlaceSR,
      MoveTime,
      ReturnTime,
      VehicleTypeSR,
      StayTimeSR,
      RecommendedStuffSR,
      RequiredStuffSR,
    } = values;

    const userData = {
      PackageId: packageId,
      DifficultyLevelSR: DifficultyLevelSR.value,
      ActivityRate: ActivityRate.value,
      Meal: Meal.value,
      DeparturePlaceSR,
      MinPrice: "",
      MoveTime,
      ReturnTime,
      VehicleTypeSR: VehicleTypeSR.value,
      StayTimeSR: StayTimeSR.value,
      RecommendedStuffSR: RecommendedStuffSR.map(function (el) {
        return el.title + " ";
      }).toString(),
      RequiredStuffSR: RequiredStuffSR.map(function (el) {
        return el.title + " ";
      }).toString(),
    };
    try {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      const { data } = await SaveTourInfoService(userData, header);
      setSubmitTracker(submitTracker + 1);
      if (stepFlag) {
        nextStepTab();
      }
      setLoading(true);
      toast.success(`اطلاعات تور با موفقیت ثبت شد.`);
      formik.resetForm();
      goToTop();
    } catch (error) {
      if (error.response && error.response.data.message) {
        setError(error.response.data.message);
        toast.error(error);
        goToTop();
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });
  return !loading ? (
    <TrackVisibility once>
      {({ isVisible }) =>
        isVisible && (
          <form
            className="flex flex-wrap justify-start items-start animate__animated animate__fadeIn"
            onSubmit={formik.handleSubmit}
          >
            <UpdateTourFormFirstStep
              formik={formik}
              hardshipLevelOptions={hardshipLevelOptions}
              activityRateOptions={activityRateOptions}
              wehicleOptions={wehicleOptions}
              stayingTimeOptions={stayingTimeOptions}
              suggestedToolsList={suggestedToolsList}
              mealOptions={mealOptions}
              suggestedToolsListHandler={suggestedToolsListHandler}
              requierdToolsList={requierdToolsList}
              requierdToolsListHandler={requierdToolsListHandler}
              suggestedToolsListRemoveHandler={suggestedToolsListRemoveHandler}
              requierdToolsListRemoveHandler={requierdToolsListRemoveHandler}
              initMoveTime={formik.values.MoveTime}
              initReturnTime={formik.values.ReturnTime}
              chnageTourHandler={chnageTourHandler}
              nextStepFlag={nextStepFlag}
              prevStepTab={prevStepTab}
            />
            {error && <p style={{ color: "red" }}>{error}</p>}
          </form>
        )
      }
    </TrackVisibility>
  ) : (
    <ContentLoading />
  );
};

export default ManageTourSecondStep;
